import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import mailchimpApiController from "../../services/mailchimp.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";
import { contentErrorMessage } from "./contentError";

const mailchimpErrorMessage = (action, fallback) => contentErrorMessage(action, fallback);

export const MailchimpUpdateKeyApi = createAsyncThunk("mailchimp/mailchimpupdatekey", async (formValues, thunkAPI) => {
  try {
    const resposedata = await mailchimpApiController
      .mailchimpupdatekey(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "mailchimpupdatekey"))
      .catch((error) => HandleError(thunkAPI, error, "mailchimpupdatekey"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const MailchimpSubscribeApi = createAsyncThunk("mailchimp/mailchimpsubscribe", async (formValues, thunkAPI) => {
  try {
    const resposedata = await mailchimpApiController
      .mailchimpsubscribe(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "mailchimpsubscribe"))
      .catch((error) => HandleError(thunkAPI, error, "mailchimpsubscribe"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const MailchimpCampaignCreateApi = createAsyncThunk("mailchimp/MailchimpCampaignCreateApi", async (formValues, thunkAPI) => {
  try {
    const resposedata = await mailchimpApiController
      .mailchimpCampaignCreate(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "MailchimpCampaignCreateApi"))
      .catch((error) => HandleError(thunkAPI, error, "MailchimpCampaignCreateApi"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const MailchimpCampaignDeleteApi = createAsyncThunk("mailchimp/MailchimpCampaignDeleteApi", async (formValues, thunkAPI) => {
  try {
    const resposedata = await mailchimpApiController
      .mailchimpCampaignDelete(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "MailchimpCampaignDeleteApi"))
      .catch((error) => HandleError(thunkAPI, error, "MailchimpCampaignDeleteApi"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  isMailchimp: "",
  isMailchimpError: "",
  isMailchimpSubscribe: "",
  isMailchimpSubscribeError: "",
  isMailchimpCampaignCreate: "",
  isMailchimpCampaignCreateError: "",
  isMailchimpCampaignDelete: "",
  isMailchimpCampaignDeleteError: "",
  isApiStatus: {
    MailchimpUpdateKeyApi: "",
    MailchimpSubscribeApi: "",
    MailchimpCampaignCreateApi: "",
    MailchimpCampaignDeleteApi: "",
  },
};

const mailchimpSlice = createSlice({
  name: "mailchimp",
  initialState,
  reducers: {
    reset: () => initialState,
    OpenMailchimpForm: (state, action) => {
      state.isOpenedMailchimpForm = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(MailchimpUpdateKeyApi.pending, (state) => {
        state.isMailchimpError = "";
        state.isApiStatus = { ...state.isApiStatus, MailchimpUpdateKeyApi: "loading" };
      })
      .addCase(MailchimpUpdateKeyApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, MailchimpUpdateKeyApi: "succeeded" };
        state.isMailchimp = action.payload;
        state.isMailchimpError = "";
      })
      .addCase(MailchimpUpdateKeyApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, MailchimpUpdateKeyApi: "failed" };
        state.isMailchimpError = mailchimpErrorMessage(action, "Unable to save Mailchimp settings.");
      })
      .addCase(MailchimpSubscribeApi.pending, (state) => {
        state.isMailchimpSubscribeError = "";
        state.isApiStatus = { ...state.isApiStatus, MailchimpSubscribeApi: "loading" };
      })
      .addCase(MailchimpSubscribeApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, MailchimpSubscribeApi: "succeeded" };
        state.isMailchimpSubscribe = action.payload;
        state.isMailchimpSubscribeError = "";
      })
      .addCase(MailchimpSubscribeApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, MailchimpSubscribeApi: "failed" };
        state.isMailchimpSubscribeError = mailchimpErrorMessage(action, "Unable to subscribe contact.");
      })
      .addCase(MailchimpCampaignCreateApi.pending, (state) => {
        state.isMailchimpCampaignCreateError = "";
        state.isApiStatus = { ...state.isApiStatus, MailchimpCampaignCreateApi: "loading" };
      })
      .addCase(MailchimpCampaignCreateApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, MailchimpCampaignCreateApi: "succeeded" };
        state.isMailchimpCampaignCreate = action.payload;
        state.isMailchimpCampaignCreateError = "";
      })
      .addCase(MailchimpCampaignCreateApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, MailchimpCampaignCreateApi: "failed" };
        state.isMailchimpCampaignCreateError = mailchimpErrorMessage(action, "Unable to create campaign.");
      })
      .addCase(MailchimpCampaignDeleteApi.pending, (state) => {
        state.isMailchimpCampaignDeleteError = "";
        state.isApiStatus = { ...state.isApiStatus, MailchimpCampaignDeleteApi: "loading" };
      })
      .addCase(MailchimpCampaignDeleteApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, MailchimpCampaignDeleteApi: "succeeded" };
        state.isMailchimpCampaignDelete = action.payload;
        state.isMailchimpCampaignDeleteError = "";
      })
      .addCase(MailchimpCampaignDeleteApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, MailchimpCampaignDeleteApi: "failed" };
        state.isMailchimpCampaignDeleteError = mailchimpErrorMessage(action, "Unable to delete campaign.");
      });

  },
});
// Action creators are generated for each case reducer function
export const { reset, OpenMailchimpForm } = mailchimpSlice.actions;
export default mailchimpSlice.reducer;
